import { pxToEm } from 'util/pxToEm';
import { Box, Typography } from '@mui/material';
import { AddIcon } from 'components/icons';
import { Link } from 'components/lib';
import React, { CSSProperties, ReactElement, ReactNode } from 'react';

export type AddLinkProps = {
  children: ReactNode;
  href?: string;
  onClick?: () => void;
  textStyle?: CSSProperties;
} & (
  | {
      href: string;
    }
  | {
      onClick: () => void;
    }
);

export const AddLink = ({
  href,
  onClick,
  children,
  textStyle,
}: AddLinkProps): ReactElement => {
  return (
    <Box display="inline-block">
      <Link href={href} onClick={onClick}>
        <Box display="flex" alignItems="center">
          <Box mr={5} lineHeight={0} fontSize="1.25em">
            <AddIcon />
          </Box>
          <Typography
            style={{
              fontWeight: 500,
              whiteSpace: 'nowrap',
              fontSize: pxToEm(14),
              color: '#23305F',
              ...textStyle,
            }}
          >
            {children}
          </Typography>
        </Box>
      </Link>
    </Box>
  );
};
